<mydocma-mm-structure-addresses
  [addresses]="currentAddresses"
  [structure]="currentStructure"
  [dialogMode]="dialogMode"
  (isExpanded)="isExpanded = $event"
  (closeMenu)="closeDialog()"
  style="width: 100%; height: 100%">
</mydocma-mm-structure-addresses>
